import 'vue-stream-markdown/index.css'
import '../css/app.css'
import './bootstrap'

import { createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { createPinia } from 'pinia'
import { createApp, Fragment, h } from 'vue'
import { ZiggyVue } from '../../vendor/tightenco/ziggy'
import { dropStalePartialReloads } from './Common/util/inertia/dropStalePartialReloads'
import { enableTouchDragDrop } from './Common/util/touchDragDrop'
import AgentChatMount from './Components/Agent/AgentChatMount.vue'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel'

enableTouchDragDrop()
dropStalePartialReloads()

import { sentryPlugin } from './util/sentry'

createInertiaApp({
  title: (title) => (title === 'Home' ? `${appName}` : `${title} - ${appName}`),
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue')
    ),
  setup({ el, App: inertiaApp, props, plugin }) {
    createApp({
      render: () => h(Fragment, [h(inertiaApp, props), h(AgentChatMount)]),
    })
      .use(plugin)
      .use(sentryPlugin)
      .use(createPinia())
      .use(ZiggyVue)
      .mount(el)
  },
  progress: {
    color: '#818cf8',
  },
})
